<template>
  <div>
    <div class="card card-custom gutter-b">
      <div class="card-header border-0 py-5">
        <h3 class="card-title align-items-start flex-column">
          <span class="card-label font-weight-bolder text-dark">
            {{ isUpdate ? "Editar Pacote de Novidades" : "Novo Pacote de Novidades" }}
          </span>
        </h3>
        <div class="card-toolbar">
          <router-link
            :to="{ name: 'novidadesAdmin' }"
            class="btn btn-light font-weight-bolder font-size-sm mr-2"
          >
            Voltar
          </router-link>
          <button
            class="btn btn-dark font-weight-bolder font-size-sm"
            @click="salvar"
            :disabled="salvando"
          >
            <b-spinner small v-if="salvando" class="mr-2" />
            Salvar pacote
          </button>
        </div>
      </div>

      <div class="card-body">
        <div v-if="carregando" class="text-center py-10">
          <b-spinner variant="primary" />
          <p class="mt-3 text-muted">Carregando...</p>
        </div>

        <div v-else>
          <!-- DADOS DO PACOTE -->
          <h5 class="font-weight-bolder text-dark mb-5">Dados do Pacote</h5>

          <b-row>
            <b-col md="8">
              <b-form-group label="Título *" label-for="titulo">
                <b-form-input
                  id="titulo"
                  v-model="form.titulo"
                  placeholder="Ex: Novidades de Maio no Sistema Nuts"
                  :state="form.titulo ? null : false"
                />
                <b-form-invalid-feedback>O título é obrigatório.</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Versão" label-for="versao">
                <b-form-input
                  id="versao"
                  v-model="form.versao"
                  placeholder="Ex: 2.5.0"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="12">
              <b-form-group label="Descrição curta" label-for="descricao_curta">
                <b-form-input
                  id="descricao_curta"
                  v-model="form.descricao_curta"
                  placeholder="Resumo exibido no card do dashboard"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="12">
              <b-form-group label="Descrição completa" label-for="descricao">
                <b-form-textarea
                  id="descricao"
                  v-model="form.descricao"
                  rows="4"
                  placeholder="Descrição detalhada do pacote"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="4">
              <b-form-group label="Data de publicação" label-for="data_publicacao">
                <b-form-input
                  id="data_publicacao"
                  type="date"
                  v-model="form.data_publicacao"
                />
              </b-form-group>
            </b-col>
            <b-col md="4" class="d-flex align-items-center pt-4">
              <b-form-checkbox v-model="form.publicado" switch>
                Publicado
              </b-form-checkbox>
            </b-col>
            <b-col md="4" class="d-flex align-items-center pt-4">
              <b-form-checkbox v-model="form.destacar_dashboard" switch>
                Destacar no dashboard
              </b-form-checkbox>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="4" class="d-flex align-items-center">
              <b-form-checkbox v-model="form.exibir_modal" switch>
                Exibir modal ao entrar
              </b-form-checkbox>
            </b-col>
          </b-row>

          <hr class="my-8" />

          <!-- ITENS DO PACOTE -->
          <div class="d-flex justify-content-between align-items-center mb-5">
            <h5 class="font-weight-bolder text-dark mb-0">Itens do Pacote</h5>
            <button
              type="button"
              class="btn btn-light-primary font-weight-bolder font-size-sm"
              @click="adicionarItem"
            >
              + Adicionar item
            </button>
          </div>

          <div v-if="form.itens.length === 0" class="text-center text-muted py-8">
            Nenhum item adicionado. Clique em "+ Adicionar item" para começar.
          </div>

          <div
            v-for="(item, index) in form.itens"
            :key="item._key"
            class="card border mb-4"
          >
            <div class="card-header py-3 d-flex align-items-center justify-content-between">
              <span class="font-weight-bolder">
                Item {{ index + 1 }}
                <span class="text-muted ml-2" v-if="item.titulo">— {{ item.titulo }}</span>
              </span>
              <div>
                <button
                  type="button"
                  class="btn btn-icon btn-sm btn-light-danger"
                  v-b-tooltip.hover title="Remover item"
                  @click="removerItem(index)"
                >
                  <TrashCan :size="14" />
                </button>
              </div>
            </div>
            <div class="card-body">
              <b-row>
                <b-col md="8">
                  <b-form-group label="Título do item *" :label-for="`item-titulo-${index}`">
                    <b-form-input
                      :id="`item-titulo-${index}`"
                      v-model="item.titulo"
                      placeholder="Ex: Orçamentos com fotos de produtos"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group label="Tipo" :label-for="`item-tipo-${index}`">
                    <select
                      :id="`item-tipo-${index}`"
                      v-model="item.tipo"
                      class="form-control"
                    >
                      <option v-for="t in tiposItem" :key="t.value" :value="t.value">
                        {{ t.label }}
                      </option>
                    </select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="12">
                  <b-form-group label="Descrição curta" :label-for="`item-desc-curta-${index}`">
                    <b-form-input
                      :id="`item-desc-curta-${index}`"
                      v-model="item.descricao_curta"
                      placeholder="Breve descrição da novidade"
                    />
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="12">
                  <b-form-group label="Descrição completa" :label-for="`item-desc-completa-${index}`">
                    <b-form-textarea
                      :id="`item-desc-completa-${index}`"
                      v-model="item.descricao"
                      rows="3"
                      placeholder="Detalhes da novidade"
                    />
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="4">
                  <b-form-group label="Ícone" :label-for="`item-icone-${index}`">
                    <b-form-input
                      :id="`item-icone-${index}`"
                      v-model="item.icone"
                      placeholder="Ex: star, check-circle"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group label="Link de vídeo" :label-for="`item-video-${index}`">
                    <b-form-input
                      :id="`item-video-${index}`"
                      v-model="item.video_url"
                      placeholder="https://youtube.com/..."
                    />
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group label="Link de documentação" :label-for="`item-doc-${index}`">
                    <b-form-input
                      :id="`item-doc-${index}`"
                      v-model="item.documentacao_url"
                      placeholder="https://docs.nuts..."
                    />
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="2">
                  <b-form-group label="Ordem" :label-for="`item-ordem-${index}`">
                    <b-form-input
                      :id="`item-ordem-${index}`"
                      type="number"
                      v-model.number="item.ordem"
                      min="1"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
      </div>

      <div class="card-footer d-flex justify-content-end" v-if="!carregando">
        <router-link :to="{ name: 'novidadesAdmin' }" class="btn btn-light mr-3">
          Cancelar
        </router-link>
        <button class="btn btn-dark font-weight-bolder" @click="salvar" :disabled="salvando">
          <b-spinner small v-if="salvando" class="mr-2" />
          Salvar pacote
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { SistemaMixin } from "@/modules/Application";
import { mapGetters } from "vuex";
import TrashCan from "vue-material-design-icons/TrashCan.vue";

let _keyCounter = 0;

export default {
  name: "app-novidades-admin-form",
  mixins: [SistemaMixin],
  components: {
    TrashCan,
  },
  data() {
    return {
      carregando: false,
      salvando: false,
      form: {
        titulo: "",
        versao: "",
        descricao_curta: "",
        descricao: "",
        data_publicacao: "",
        publicado: false,
        destacar_dashboard: false,
        exibir_modal: false,
        itens: [],
      },
      tiposItem: [
        { value: "funcionalidade", label: "Nova funcionalidade" },
        { value: "melhoria", label: "Melhoria" },
        { value: "correcao", label: "Correção" },
        { value: "comunicado", label: "Comunicado" },
        { value: "treinamento", label: "Treinamento" },
        { value: "importante", label: "Importante" },
      ],
    };
  },
  computed: {
    isUpdate() {
      return !!this.$route.params.id;
    },
    ...mapGetters(["isNuts"]),
  },
  async mounted() {
    if (!this.isNuts) {
      this.$router.push({ name: "dashboard" });
      return;
    }
    this.$store.dispatch("setLoading", false);
    if (this.isUpdate) {
      await this.carregar();
    }
  },
  methods: {
    async carregar() {
      this.carregando = true;
      try {
        const { data } = await this.$http.post("/novidades/admin/find", {
          id: this.$route.params.id,
        });
        const pacote = data.data || data;
        this.form = {
          titulo: pacote.titulo || "",
          versao: pacote.versao || "",
          descricao_curta: pacote.descricao_curta || "",
          descricao: pacote.descricao || "",
          data_publicacao: pacote.data_publicacao
            ? pacote.data_publicacao.substring(0, 10)
            : "",
          publicado: !!pacote.publicado,
          destacar_dashboard: !!pacote.destacar_dashboard,
          exibir_modal: !!pacote.exibir_modal,
          itens: (pacote.itens || []).map((item) => ({
            ...item,
            _key: ++_keyCounter,
          })),
        };
      } catch (error) {
        this.$toast.error(
          error?.response?.data?.msg ||
          error?.response?.data?.message ||
          "Não foi possível carregar o pacote."
        );
        this.$router.push({ name: "novidadesAdmin" });
      } finally {
        this.carregando = false;
      }
    },

    adicionarItem() {
      this.form.itens.push({
        _key: ++_keyCounter,
        titulo: "",
        tipo: "funcionalidade",
        descricao_curta: "",
        descricao: "",
        icone: "",
        imagem: "",
        video_url: "",
        documentacao_url: "",
        ordem: this.form.itens.length + 1,
      });
    },

    removerItem(index) {
      this.form.itens.splice(index, 1);
    },

    async salvar() {
      if (!this.form.titulo || !this.form.titulo.trim()) {
        this.$toast.error("O título do pacote é obrigatório.");
        return;
      }

      this.salvando = true;
      try {
        const payload = {
          ...this.form,
          itens: this.form.itens.map(({ _key, ...item }) => item),
        };

        if (this.isUpdate) {
          await this.$http.post("/novidades/admin/update", {
            id: this.$route.params.id,
            ...payload,
          });
        } else {
          await this.$http.post("/novidades/admin/create", payload);
        }

        this.$toast.success("Pacote de novidades salvo com sucesso.");
        this.$router.push({ name: "novidadesAdmin" });
      } catch (error) {
        this.$toast.error(
          error?.response?.data?.msg ||
          error?.response?.data?.message ||
          "Não foi possível salvar o pacote."
        );
      } finally {
        this.salvando = false;
      }
    },
  },
};
</script>
